import { render } from "./ThemeColorForm.vue?vue&type=template&id=da23cae8&scoped=true"
import script from "./ThemeColorForm.vue?vue&type=script&lang=js"
export * from "./ThemeColorForm.vue?vue&type=script&lang=js"

import "./ThemeColorForm.vue?vue&type=style&index=0&id=da23cae8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da23cae8"]])

export default __exports__